import { render, staticRenderFns } from "./ScormViewer.vue?vue&type=template&id=c63f7718&scoped=true"
import script from "./ScormViewer.vue?vue&type=script&lang=js"
export * from "./ScormViewer.vue?vue&type=script&lang=js"
import style0 from "./ScormViewer.vue?vue&type=style&index=0&id=c63f7718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63f7718",
  null
  
)

export default component.exports